import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.radical.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_RADICAL_ASYNC: `${uid}.saveRadicalAsync`,
    SAVE_RADICAL_SUCCESS: `${uid}.saveRadicalSuccess`,
    SAVE_RADICAL_FAILURE: `${uid}.saveRadicalFailure`,
    CREATE_RADICAL: `${uid}.createRadical`
};

export { ActionTypes };
